class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const limit = parseInt(this.dataset.limit, 10) || 4;
    if (!productId) return;

    fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`)
      .then((r) => r.json())
      .then(({ products }) => {
        if (!products || !products.length) {
          this.closest('.pdp-recs')?.remove();
          return;
        }
        const grid = this.querySelector('[data-recs-grid]');
        if (!grid) return;
        grid.innerHTML = products.map((p) => this._card(p)).join('');
      })
      .catch(() => this.closest('.pdp-recs')?.remove());
  }

  _card(p) {
    const imgSrc = p.featured_image
      ? p.featured_image.replace(/^\/\//, 'https://')
      : null;
    const img = imgSrc
      ? `<img src="${imgSrc}" alt="${this._esc(p.title)}" loading="lazy" width="400" height="500">`
      : '';
    const price = this._formatMoney(p.price);
    const onSale = p.compare_at_price && p.compare_at_price > p.price;
    const comparePrice = onSale
      ? `<s class="pdp-rec-card__was">${this._formatMoney(p.compare_at_price)}</s>`
      : '';
    const badge = onSale
      ? `<span class="pdp-rec-card__badge">–${Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100)}%</span>`
      : '';

    return `<a href="${p.url}" class="pdp-rec-card">
      <div class="pdp-rec-card__img-wrap">${img}${badge}</div>
      <div class="pdp-rec-card__meta">
        <span class="pdp-rec-card__title">${this._esc(p.title)}</span>
        <span class="pdp-rec-card__price${onSale ? ' pdp-rec-card__price--sale' : ''}">${price}${comparePrice}</span>
      </div>
    </a>`;
  }

  _formatMoney(cents) {
    if (typeof TB !== 'undefined' && TB.formatMoney) {
      return TB.formatMoney(cents);
    }
    return (cents / 100).toLocaleString('sv-SE') + '\u00a0kr';
  }

  _esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

customElements.define('product-recommendations', ProductRecommendations);
